/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { cloneElement, useCallback, useEffect, useState } from 'react'
import { FormInputProps } from 'shared'
import validateJS from 'validate.js'

validateJS.validators.presence.message = 'blank'
validateJS.validators.length.tooLong = 'too_long'
validateJS.validators.length.tooShort = 'too_short'

const getFirstChild = (children?: React.ReactNode) => {
  const len = React.Children.count(children)
  if (!len) return null
  const child = React.Children.toArray(children)[0]
  return child as React.ReactElement
}

// TODO for Kamil
export const FormValidator = (
  props: { children?: React.ReactNode; presence?: any; length?: any; eager?: boolean } & FormInputProps
) => {
  const { children, field, form, eager, ...validations } = props
  const [error, setError] = useState<string | null>(null)
  const [focus, setFocus] = useState<boolean | undefined>(undefined)
  const [value, setValue] = useState(null)
  const child = getFirstChild(children)

  // console.log(props)
  const validate = useCallback(() => {
    const errors = validateJS.single(value, validations) || []

    setError(errors.length > 0 ? `${props.field}.${errors[0]}` : null)
  }, [validations, value, props])

  // validate on blur
  useEffect(() => {
    focus === false && validate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focus])

  // validate on every change in eager mode, otherwise only re-validate if error is showing
  useEffect(() => {
    if (value === null) return
    ;(eager || error) && validate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  // track new errors, once
  useEffect(() => {
    error
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  if (!child) return null

  return cloneElement(child, {
    errorSymbol: error,
    handleChange: (value: any) => setValue(value),
    onBlur: () => setFocus(false),
    onFocus: () => setFocus(true),
  })
}
